import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IStorage, IBridgeOptions } from './interface'

/**
 * 保存本地数据
 *
 * @param {IBridgeOptions<IStorage>} {
 *   key,
 *   value,
 *   scope,
 *   domain,
 *   multi_param,
 *   success,
 *   fail,
 *   complete
 * }
 */
function setStorageSync({
  key,
  value,
  scope,
  domain,
  multi_param,
  success,
  fail,
  complete
}: IBridgeOptions<IStorage>) {
  const params = {
    key,
    value,
    scope,
    domain,
    multi_param
  }
  const opts = {
    method: 'native.writeData',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('setStorageSync error: ', error)
  }
}

/**
 * 保存本地数据
 * 一个异步接口，支持 Promise 化使用
 * @param {IBridgeOptions<IStorage>} { key, value, scope, domain, multi_param }
 * @returns
 */
function setStorage({ key, value, scope, domain, multi_param }: IBridgeOptions<IStorage>) {
  const params = {
    key,
    value,
    scope,
    domain,
    multi_param
  }
  const opts = {
    method: 'native.writeData',
    params
  }

  return nativeJSBridge(opts)
}

export { setStorage, setStorageSync }
